import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-title fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_4 = {
  key: 0,
  class: "modal-footer p-2"
}
const _hoisted_5 = { class: "row w-100" }
const _hoisted_6 = { class: "col-6 ps-0" }
const _hoisted_7 = ["type"]
const _hoisted_8 = { class: "col-6 pe-0 text-end" }

import { reactive, onMounted, watch, computed, ref } from "vue";

//componentes
import { Modal } from "bootstrap";

interface IProps {
  id: string,
  exibir: boolean,
  botaoFechar?: boolean,
  botaoSim?: boolean,
  botaoConfirmar?: boolean,
  botaoNao?: boolean,
  botaoGravar?: boolean,
  botaoGravarTipo?: 'button' | 'submit'
  titulo?: string,
  classBody?: string,
  classHeader?: string,
  tamanho?: 'modal-sm' | 'modal-lg' | 'modal-xl' | 'modal-md'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    id: {},
    exibir: { type: Boolean },
    botaoFechar: { type: Boolean },
    botaoSim: { type: Boolean },
    botaoConfirmar: { type: Boolean },
    botaoNao: { type: Boolean },
    botaoGravar: { type: Boolean },
    botaoGravarTipo: {},
    titulo: {},
    classBody: {},
    classHeader: {},
    tamanho: {}
  },
  emits: ["onSim", "onNao", "onOk", "onFechou", "onGravar", "onConfirmar"],
  setup(__props: any, { emit: __emit }) {


//vue
var props = __props;

const controle = reactive({
  id: props.id,
  modal: {} as Modal,
  exibir: false,
  titulo: props.titulo,
  tamanho: props.tamanho
});

// Referências para o drag
const modalDialogRef = ref<HTMLElement | null>(null);
const isDragging = ref(false);
const dragOffset = reactive({ x: 0, y: 0 });

var emit = __emit;

onMounted(() => {
  if (props.id == undefined || props.id == "")
    controle.id = "janMsgBox";
})

watch(() => props.id, async (novoValor) => {
  if (novoValor == undefined || novoValor == "")
    controle.id = "janMsgBox";
  else
    controle.id = novoValor;
})

watch(() => props.exibir, async (novoValor, antigoValor) => {
  if (novoValor == true && novoValor != antigoValor) {
    controle.exibir = true;
    exibirModal();
    controle.tamanho = props.tamanho;
  }
  else
    fecharModal();
})

watch(() => props.titulo, async (novoValor) => {
  controle.titulo = novoValor;
})

watch(() => props.tamanho, async (novoValor) => {
  controle.tamanho = novoValor;
})

function exibirModal() {
  controle.modal = new Modal(`#${controle.id}`, {})
  controle.modal.show();
}

function fecharModal() {
  controle.modal.hide();
  resetModalPosition();
  emit("onFechou");
}

const temBotoes = computed(() => {
  return props.botaoFechar || props.botaoSim || props.botaoNao || props.botaoGravar || props.botaoConfirmar;
})

// Funções de drag
function onMouseDown(e: MouseEvent) {
  if (!modalDialogRef.value) return;

  isDragging.value = true;
  const rect = modalDialogRef.value.getBoundingClientRect();
  dragOffset.x = e.clientX - rect.left;
  dragOffset.y = e.clientY - rect.top;

  // Captura a largura atual antes de mudar para fixed
  modalDialogRef.value.style.width = `${rect.width}px`;

  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
}

function onMouseMove(e: MouseEvent) {
  if (!isDragging.value || !modalDialogRef.value) return;

  const newX = e.clientX - dragOffset.x;
  const newY = e.clientY - dragOffset.y;

  modalDialogRef.value.style.position = 'fixed';
  modalDialogRef.value.style.left = `${newX}px`;
  modalDialogRef.value.style.top = `${newY}px`;
  modalDialogRef.value.style.margin = '0';
}

function onMouseUp() {
  isDragging.value = false;
  document.removeEventListener('mousemove', onMouseMove);
  document.removeEventListener('mouseup', onMouseUp);
}

function resetModalPosition() {
  if (modalDialogRef.value) {
    modalDialogRef.value.style.position = '';
    modalDialogRef.value.style.left = '';
    modalDialogRef.value.style.top = '';
    modalDialogRef.value.style.margin = '';
    modalDialogRef.value.style.width = '';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: controle.id,
    tabindex: "-1",
    "data-bs-keyboard": "false",
    "data-bs-backdrop": "static"
  }, [
    _createElementVNode("div", _mergeProps({
      class: ["modal-dialog modal-dialog-centered", __props.tamanho ? __props.tamanho : '']
    }, _ctx.$attrs, {
      ref_key: "modalDialogRef",
      ref: modalDialogRef
    }), [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-header d-flex justify-content-between draggable-header", _unref(props).classHeader]),
          onMousedown: onMouseDown
        }, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(!controle?.titulo ? 'Atenção' : controle.titulo), 1),
          _createElementVNode("a", {
            type: "button",
            class: "",
            onClick: fecharModal,
            onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fa fa-times" }, null, -1)
          ]))], 32)
        ], 34),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-body", _unref(props).classBody])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2),
        (temBotoes.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_unref(props).botaoSim)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[1] || (_cache[1] = () => { _unref(emit)('onSim'); fecharModal(); })
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "fas fa-check" }, null, -1),
                        _createTextVNode(" Sim ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_unref(props).botaoConfirmar)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[2] || (_cache[2] = () => { _unref(emit)('onConfirmar'); fecharModal(); })
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fas fa-check" }, null, -1),
                        _createTextVNode(" Confirmar ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_unref(props).botaoGravar)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[3] || (_cache[3] = () => { _unref(emit)('onGravar'); }),
                        type: __props.botaoGravarTipo ? __props.botaoGravarTipo : __props.botaoGravarTipo
                      }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "fa fa-save" }, null, -1),
                        _createTextVNode(" Gravar ", -1)
                      ]))], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_unref(props).botaoNao)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-secondary btn-sm",
                        onClick: _cache[4] || (_cache[4] = () => { _unref(emit)('onNao'); fecharModal(); })
                      }, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "fas fa-times" }, null, -1),
                        _createTextVNode(" Não ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_unref(props).botaoFechar)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "btn btn-secondary btn-sm",
                        type: "button",
                        onClick: fecharModal
                      }, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fas fa-times" }, null, -1),
                        _createTextVNode(" Fechar ", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 16)
  ], 8, _hoisted_1))
}
}

})